<template>
    <div class="staff">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>公司配置</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>开票设置</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :model="editForm" label-width="80px" :inline="true">
                    <el-form-item label="开票设置:">
                        <el-checkbox v-model="editForm.invoiceFront">前台开票</el-checkbox>
                        <el-checkbox v-model="editForm.invoiceBack" :disabled="true">后台开票</el-checkbox>
                    </el-form-item>
                    <el-button type="primary" style="margin-top: 5px;margin-left: 20px" @click="onSubmit" size="mini">确 定</el-button>
                </el-form>

            </el-card>

        </main>
    </div>
</template>
<script>
    export default {
        data() {

            return {
                editForm: {
                    id: "",
                    invoiceFront: "",
                    invoiceBack: ""
                },
                oldForm: {
                    id: "",
                    invoiceFront: "",
                    invoiceBack: ""
                },

                rules: {
                    password: [
                        { required: true, message: '请输入原密码', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            onSubmit() {
                if(this.editForm.invoiceFront == this.oldForm.invoiceFront
                &&this.editForm.invoiceBack == this.oldForm.invoiceBack){
                    return;
                }
                let _this = this;
                this.$axios.post("/admin/company/saveInvoiceType", this.editForm)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {
                            _this.$notify({
                                title: '成功',
                                message: '设置成功',
                                type: 'success'
                            });
                            _this.initData();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            },

            initData(){
                let _this = this;
                this.$axios.post("/admin/company/companyData")
                    .then(function (response) {
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            _this.editForm.id = resp.data.id;
                            _this.editForm.invoiceFront = resp.data.invoiceFront;
                            _this.editForm.invoiceBack = resp.data.invoiceBack;
                            _this.oldForm =  {..._this.editForm};

                        }

                    });
            }
        },
        created() {
            this.initData();
        },
    }
</script>
<style>
</style>
